import { useMemo } from 'react';

import LayoutMain from '@Layouts/LayoutMain';
import QualityDepartment from '@Components/QualityDepartment';
import Requisites from '@Components/Requisites';
import PageTopBar from '@Components/PageTopBar';
import usePage from '@Queries/usePage';
import useTranslation from '@Queries/useTranslation';
// import ButtonsContactForms from './elements/ButtonsContactForms';
import ShowroomsMap from '@Components/ShowroomsMap';
import Page from '@Components/Page';
import styles from './PageContacts.module.css';

import type { PageContactsData } from './typings';
import type { FC } from 'react';

const PageContacts: FC = () => {
  const pageData = usePage<PageContactsData>();
  const { data: page } = pageData;
  const { organization, map, contacts } = page;
  const { t } = useTranslation();

  const adresses = useMemo(() => {
    return (page.pickUpPoints || []).map((pickUpPoint) => {
      const { postalCode, addressLocality, streetAddress, additional } = pickUpPoint.address;
      const chunks = [postalCode, addressLocality, streetAddress, additional];

      return chunks.filter(Boolean).join(', ');
    });
  }, [page.pickUpPoints]);

  return (
    <LayoutMain>
      <Page>
        <PageTopBar title={page.meta.h1} breadcrumbs={page.breadcrumbs} />
        <div data-testid='page-contacts'>
          <div
            className={styles.containerNarrow}
            itemScope
            itemType='http://schema.org/Organization'
          >
            {adresses.length > 0 && (
              <div className={styles.hotInfoWrapper}>
                {adresses.length === 1 ? (
                  <div>{`${t('pickup-point')} ${adresses[0]}`}</div>
                ) : (
                  <ul className={styles.list}>
                    {t('pickup-points')}
                    {adresses.map((address, index) => (
                      <li className={styles.listItem} key={index}>
                        {address}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            <QualityDepartment
              className={styles.qualityDepartment}
              schedule={contacts}
              title={t('schedule')}
            />

            {organization?.requisites && (
              <Requisites className={styles.requisites} requisites={organization.requisites} />
            )}
          </div>

          {map && (
            <div className={styles.containerSeeUs}>
              <div className={styles.divider} />
              <ShowroomsMap className={styles.seeUs} map={map} />
            </div>
          )}
        </div>
      </Page>
    </LayoutMain>
  );
};

export default PageContacts;
